export default __webpack_public_path__ + "static/media/Screenshot (2).1005d1e8.png";